<div [id]="'summary-ohi-view-form-'+ Index" *ngIf="Form" [formGroup]="Form" class="form-section">
    <div [id]="'summary-ohi-view-form-section-1-'+ Index" class="form-section">
        <div class="inline-item mb-10 form-radio-group">
            <mat-radio-group required formControlName="PolicyHolderType" class="" [disabled]="true">
                <mat-radio-button [id]="'self-' + Index" value="IsSelf" [disabled]="true">Self</mat-radio-button>
                <mat-radio-button [id]="'spouse-' + Index" value="IsSpouse" [disabled]="true">Spouse</mat-radio-button>
                <mat-radio-button [id]="'dependent-' + Index" value="IsDependent" [disabled]="true">Dependent</mat-radio-button>
                <mat-radio-button [id]="'other-' + Index" value="IsOther" [disabled]="true">Other (Relationship:)</mat-radio-button>
            </mat-radio-group>
            <enterprise-text-input  [id]="'summary-ohi-view-input-po-'+ Index"
                                    Label=""
                                    formControlName="PolicyHolderOther"
                                    class="input-fill"
                                    [Appearance]="'fill'"
                                    [ReadOnly]="true"
                                    [InputId]="'summary-ohi-view-input-po-'+ Index"
                                    [InputName]="'PolicyHolderOther-'+ Index">
            </enterprise-text-input>
        </div>
    </div>
    <div [id]="'summary-ohi-view-form-section-2-'+ Index" class="inline-item mb-10">
        <enterprise-text-input  [id]="'summary-ohi-view-input-phname-'+ Index"
                                Label="Name"
                                formControlName="PolicyHolderName"
                                class="inline-form-input"
                                [Appearance]="'outline'"
                                [ReadOnly]="true"
                                [InputId]="'summary-ohi-view-input-phname-'+ Index"
                                [InputName]="'PolicyHolderName-'+ Index">
        </enterprise-text-input>
        <enterprise-date-input  [id]="'summary-ohi-view-input-dob-'+ Index"
                                Label="Date of Birth"
                                formControlName="PolicyHolderDateOfBirth"
                                class="inline-form-input"
                                [Appearance]="'outline'"
                                [ReadOnly]="true"
                                [InputId]="'summary-ohi-view-input-dob-'+ Index"
                                [InputName]="'PolicyHolderDateOfBirth-'+ Index">
        </enterprise-date-input>
        <enterprise-text-input  [id]="'summary-ohi-view-input-phidentification-'+ Index"
                                Label="ID"
                                formControlName="PolicyHolderIdentification"
                                class="inline-form-input"
                                [Appearance]="'outline'"
                                [ReadOnly]="true"
                                [InputId]="'summary-ohi-view-input-phidentification-'+ Index"
                                [InputName]="'PolicyHolderIdentification-'+ Index">
        </enterprise-text-input>
        <enterprise-text-input  [id]="'summary-ohi-view-input-phcarrier-'+ Index"
                                Label="Name of Other Carrier"
                                formControlName="PolicyHolderNameOfTheCarrier"
                                class="inline-form-input"
                                [Appearance]="'outline'"
                                [ReadOnly]="true"
                                [InputId]="'summary-ohi-view-input-phcarrier-'+ Index"
                                [InputName]="'PolicyHolderNameOfTheCarrier-'+ Index">
        </enterprise-text-input>
        <enterprise-text-input  [id]="'summary-ohi-view-input-service-'+ Index"
                                Label="Carrier Customer Service #"
                                formControlName="PolicyCarrierCustomerService"
                                class="inline-form-input"
                                [Appearance]="'outline'"
                                ButtonIcon="phone"
                                [Mask]="PhoneFormat"
                                [ButtonDisabled]="true"
                                [ShowButton]="true"
                                [ReadOnly]="true"
                                [InputId]="'summary-ohi-view-input-service-'+ Index"
                                [InputName]="'PolicyCarrierCustomerService-'+ Index">
        </enterprise-text-input>
    </div>
    <div [id]="'summary-ohi-view-form-ph-'+Index+ '-pm-section'" *ngIf="PolicyMembers?.controls?.length > 0 else noMembers">
        <div formArrayName="PolicyMembers">
            <div *ngFor="let policyMember of PolicyMembers.controls; let indexMember=index" [id]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember" [formGroupName] = "indexMember" class="inline-item mb-10">
                <enterprise-text-input  [id]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'input-pmname'"
                                        Label="Name"
                                        formControlName="PolicyMemberName"
                                        class="inline-form-input"
                                        [Appearance]="'outline'"
                                        [ReadOnly]="true"
                                        [InputId]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'-input-pmname'"
                                        [InputName]="'PolicyMemberName-'+Index+ '-pm-'+indexMember+'-input-pmname'">
                </enterprise-text-input>
                <enterprise-date-input  [id]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'input-pmdob'"
                                        Label="Date of Birth"
                                        formControlName="PolicyMemberDateOfBirth"
                                        class="inline-form-input"
                                        [Appearance]="'outline'"
                                        [ReadOnly]="true"
                                        [InputId]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'-input-pmdob'"
                                        [InputName]="'PolicyMemberDateOfBirth-'+Index+ '-pm-'+indexMember+'-input-pmdob'">
                </enterprise-date-input>
                <enterprise-text-input  [id]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'-input-pmidentification'"
                                        Label="ID"
                                        formControlName="PolicyMemberIdentification"
                                        class="inline-form-input"
                                        [Appearance]="'outline'"
                                        [ReadOnly]="true"
                                        [InputId]="'summary-ohi-view-form-ph-'+Index+ '-pm-'+indexMember+'-input-pmidentification'"
                                        [InputName]="'PolicyMemberIdentification-'+Index+ '-pm-'+indexMember+'-input-pmidentification'">
                </enterprise-text-input>
            </div>
        </div>
    </div>
</div>
<ng-template #noMembers>
</ng-template>
